import { render, staticRenderFns } from "./signModify.vue?vue&type=template&id=4a81aafe&scoped=true&"
import script from "./signModify.vue?vue&type=script&lang=js&"
export * from "./signModify.vue?vue&type=script&lang=js&"
import style0 from "./signModify.vue?vue&type=style&index=0&id=4a81aafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81aafe",
  null
  
)

export default component.exports